import {
    CANCEL_BOOKING_REQUEST,
    CANCEL_BOOKING_SUCCESS,
    CANCEL_BOOKING_FAILURE,
    ASSIGN_TRIP_REQUEST,
    ASSIGN_TRIP_SUCCESS,
    ASSIGN_TRIP_FAILURE,
    GET_NEW_BOOKINGS_REQUEST,
    GET_NEW_BOOKINGS_SUCCESS,
    GET_NEW_BOOKINGS_FAILURE,
    GET_CANCEL_REASON_REQUEST,
    GET_CANCEL_REASON_SUCCESS,
    GET_CANCEL_REASON_FAILURE,
    AUTO_ASSIGN_TRIP_REQUEST,
    AUTO_ASSIGN_TRIP_SUCCESS,
    AUTO_ASSIGN_TRIP_FAILURE,
    RESET_AUTO_ASSIGN_STATE,
    GET_AVAILABLE_CABS_RADIUS_REQUEST,
    GET_AVAILABLE_CABS_RADIUS_SUCCESS,
    GET_AVAILABLE_CABS_RADIUS_FAILURE,
    GET_AVAILABLE_CABS_RADIUS_RESET,
    GET_SELECTED_CAB_REQUEST,
    GET_SELECTED_CAB_SUCCESS,
    GET_SELECTED_CAB_FAILURE,
    RESET_SELECTED_CAB,
} from "../actions/newAction";

const initialState = {
    loading: false,
    cancelData: null,
    assignData: null,
    assignTripLoading: false,
    newBookings: [],
    newBookingsLoading: false,
    newBookingsError: null,
    cancelReasons: [],
    cancelReasonsLoading: false,
    cancelReasonsError: null,
    error: null,
    todaycount: 0,
    autoAssignLoading: false,
    autoAssignData: null,
    autoAssignError: null,
    availableCabsRadius: [],
    availableCabsRadiusLoading: false,
    availableCabsRadiusError: null,
    selectedCab: null,
    selectedCabLoading: false,
    selectedCabError: null,
    updateBookingLoading: false,
    updateBookingSuccess: false,
    updateBookingError: null as string | null,
};

const newBookingReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case CANCEL_BOOKING_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case CANCEL_BOOKING_SUCCESS:
            return {
                ...state,
                loading: false,
                cancelData: action.payload,
            };
        case CANCEL_BOOKING_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case ASSIGN_TRIP_REQUEST:
            return {
                ...state,
                loading: true,
                assignTripLoading: true,
                error: null,
            };
        case ASSIGN_TRIP_SUCCESS:
            return {
                ...state,
                loading: false,
                assignTripLoading: false,
                assignData: action.payload,
            };
        case ASSIGN_TRIP_FAILURE:
            return {
                ...state,
                loading: false,
                assignTripLoading: false,
                error: action.payload,
            };
        case "ASSIGN_TRIP_RESET":
            return {
                ...state,
                assignData: null,
                assignTripLoading: false,
            };
        case GET_NEW_BOOKINGS_REQUEST:
            return { ...state, newBookingsLoading: true, newBookingsError: null, cancelData: null, assignData: null };
        case GET_NEW_BOOKINGS_SUCCESS:
            return {
                ...state,
                newBookingsLoading: false,
                newBookings: Array.isArray(action.payload?.bookings) ? action.payload.bookings : [],
                todaycount: action.payload?.todaycount !== undefined ? action.payload.todaycount : 0,
            };
        case GET_NEW_BOOKINGS_FAILURE:
            return { ...state, newBookingsLoading: false, newBookingsError: action.payload };

        // GET CANCEL REASONS
        case GET_CANCEL_REASON_REQUEST:
            return { ...state, cancelReasonsLoading: true, cancelReasonsError: null };
        case GET_CANCEL_REASON_SUCCESS:
            return { ...state, cancelReasonsLoading: false, cancelReasons: action.payload };
        case GET_CANCEL_REASON_FAILURE:
            return { ...state, cancelReasonsLoading: false, cancelReasonsError: action.payload };

        case "UPDATE_NEW_BOOKING_REQUEST":
            return { ...state, updateBookingLoading: true, updateBookingSuccess: false, updateBookingError: null };

        case "UPDATE_NEW_BOOKING_SUCCESS":
            return { ...state, updateBookingLoading: false, updateBookingSuccess: true };

        case "UPDATE_NEW_BOOKING_FAILURE":
            return { ...state, updateBookingLoading: false, updateBookingError: action.payload };

        case "UPDATE_NEW_BOOKING_RESET":
            return { ...state, updateBookingLoading: false, updateBookingSuccess: false, updateBookingError: null };

        // AUTO ASSIGN
        case AUTO_ASSIGN_TRIP_REQUEST:
            return {
                ...state,
                autoAssignLoading: true,
                autoAssignData: null,
                autoAssignError: null,
            };

        case AUTO_ASSIGN_TRIP_SUCCESS:
            return {
                ...state,
                autoAssignLoading: false,
                autoAssignData: action.payload,
                autoAssignError: null,
            };

        case AUTO_ASSIGN_TRIP_FAILURE:
            return {
                ...state,
                autoAssignLoading: false,
                autoAssignData: null,
                autoAssignError: action.payload,
            };

        case RESET_AUTO_ASSIGN_STATE:
            return {
                ...state,
                autoAssignLoading: false,
                autoAssignData: null,
                autoAssignError: null,
            };

        // Available cab

        case GET_AVAILABLE_CABS_RADIUS_REQUEST:
            return {
                ...state,
                availableCabsRadiusLoading: true,
                availableCabsRadiusError: null,
            };

        case GET_AVAILABLE_CABS_RADIUS_SUCCESS:
            return {
                ...state,
                availableCabsRadiusLoading: false,
                availableCabsRadius: action.payload,
            };

        case GET_AVAILABLE_CABS_RADIUS_FAILURE:
            return {
                ...state,
                availableCabsRadiusLoading: false,
                availableCabsRadiusError: action.payload,
            };

        case GET_AVAILABLE_CABS_RADIUS_RESET:
            return {
                ...state,
                availableCabsRadius: [],
                availableCabsRadiusLoading: false,
                availableCabsRadiusError: null,
            };


        // GET SELECTED CAB
        case GET_SELECTED_CAB_REQUEST:
            return {
                ...state,
                selectedCabLoading: true,
                selectedCabError: null,
            };

        case GET_SELECTED_CAB_SUCCESS:
            return {
                ...state,
                selectedCabLoading: false,
                selectedCab: action.payload,
            };

        case GET_SELECTED_CAB_FAILURE:
            return {
                ...state,
                selectedCabLoading: false,
                selectedCabError: action.payload,
            };

        case RESET_SELECTED_CAB:
            return {
                ...state,
                selectedCab: null,
            };

        default:
            return state;
    }
};

export default newBookingReducer;
